export default "/images/vendor/flag-icons/flags/1x1/bb.svg?8f344222ecda4609aaeee1339cca336a";